import React from 'react';

import { UiDialog } from '../ui/ui-dialog';

import { MergeIntegrationDetails } from './merge-integration-details';

type MergeIntegrationDetailsDialogProps = {
  title: string;
  onClose: () => void;
  org: Org;
};

export const MergeIntegrationDetailsDialog = ({
  onClose,
  org,
  title,
}: MergeIntegrationDetailsDialogProps) => (
  <UiDialog title={title} size="sm" onClose={onClose}>
    <UiDialog.Content>
      <MergeIntegrationDetails org={org} />
    </UiDialog.Content>
  </UiDialog>
);
